/**
 * Exportação PDF da proposta — texto vetorial (pesquisável), ~10 pt.
 */
import {
  buildPropostaPdfTextoReal,
  buildPropostaPdfFileName,
} from "@/lib/propostaTextoPdfExport";

const MAX_PDF_BYTES = 10 * 1024 * 1024;

/**
 * Gera o PDF da proposta (texto pesquisável) sem baixar nem imprimir.
 * @param {object} p
 * @param {object} p.proposta
 * @param {object|null} p.edital
 * @param {object} p.config
 * @param {string} p.localProposta
 * @param {string} p.dataPropostaExtenso
 * @returns {Promise<{ blob: Blob, fileName: string, sizeBytes: number, withinLimit: boolean }>}
 */
export async function buildPropostaVisualizarPdfBlob({
  proposta,
  edital,
  config,
  localProposta,
  dataPropostaExtenso,
}) {
  if (!proposta || !config) {
    throw new Error("Dados da proposta incompletos.");
  }

  const pdf = await buildPropostaPdfTextoReal({
    proposta,
    edital,
    config,
    localProposta: localProposta || "",
    dataPropostaExtenso: dataPropostaExtenso || "",
  });

  const blob = pdf.output("blob");
  const fileName = buildPropostaPdfFileName(edital);
  const sizeBytes = blob.size;
  return {
    blob,
    fileName,
    sizeBytes,
    withinLimit: sizeBytes <= MAX_PDF_BYTES,
  };
}

/**
 * @param {object} p
 * @param {object} p.proposta
 * @param {object|null} p.edital
 * @param {object} p.config
 * @param {string} p.localProposta
 * @param {string} p.dataPropostaExtenso
 * @param {boolean} [p.openPrintDialog]
 */
export async function exportPropostaVisualizarPdf({
  proposta,
  edital,
  config,
  localProposta,
  dataPropostaExtenso,
  openPrintDialog = false,
}) {
  const { blob, fileName, sizeBytes, withinLimit } = await buildPropostaVisualizarPdfBlob({
    proposta,
    edital,
    config,
    localProposta,
    dataPropostaExtenso,
  });

  if (openPrintDialog) {
    const pdfUrl = URL.createObjectURL(blob);
    const printWindow = window.open(pdfUrl);
    if (printWindow) {
      printWindow.onload = () => printWindow.print();
    }
  } else {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  return {
    sizeBytes,
    withinLimit,
  };
}
